export default function Bullet() {
    return (
        <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle id="Ellipse 2" cx="4" cy="4.5" r="4" fill="#2A2728" />
        </svg>
    );
}
